import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ROUTES } from 'config/constants';
import MyProfileMenu from 'components/MyProfileMenu/MyProfileMenu';

import './AccountLayout.scss';

const AccountLayout = ({ children }) => {
    const history = useHistory();
    const { singPassVerified } = useSelector((state) => ({
        profile: state.auth.profile,
        singPassVerified: state.auth?.profile?.singpass_status
    }));
    const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    useEffect(() => {
        if (singPassVerified === 'otp_required') {
            history.push(ROUTES.MYINFORMATION);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [singPassVerified]);

    return (
        <div className='container account__layout-container'>
            <div className='AccountLayout'>
                <div className='AccountLayout__body'>
                    {!isMobile && <div className='AccountLayout__account-nav'>
                        <MyProfileMenu />
                    </div>}
                    <div className='AccountLayout__account-content'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

AccountLayout.propTypes = {
    tabMenu: PropTypes.array.isRequired,
    isSingPassVerified: PropTypes.bool,
    shouldShow: PropTypes.bool,
    children: PropTypes.any
};

export default AccountLayout;
